/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".left-handle,   .right-handle{background:#fccf85!important;border:7px solid #fab034!important}  .bar span{background:#fccf85!important}  div.filler{border:1px solid #fccf85!important}  .handle-tooltip{border:1px solid #000!important;color:#000!important}"];
export { styles as styles };
